import { render, staticRenderFns } from "./MyAssTask.vue?vue&type=template&id=2cfdeb4e&scoped=true"
import script from "./MyAssTask.vue?vue&type=script&lang=js"
export * from "./MyAssTask.vue?vue&type=script&lang=js"
import style0 from "./MyAssTask.vue?vue&type=style&index=0&id=2cfdeb4e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfdeb4e",
  null
  
)

export default component.exports